import { Component, ViewEncapsulation, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-show-code',
  templateUrl: './show-code.component.html',
  styleUrls: ['./show-code.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ShowCodeComponent implements OnInit {

  editorOptions = {
    theme: 'vs-dark',
    language: 'html',
    readOnly: true,
    selectionHighlight: true
  };

  @Input('data') data: string;

  constructor() {

  }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/show-code/show-code.component.ts